import type { ComponentPropsWithoutRef } from "react";

/** A 40px round outlined button holding an icon (section 11.0 mockup). */
export function IconButton({
  className = "",
  type = "button",
  ...props
}: ComponentPropsWithoutRef<"button"> & { "aria-label": string }) {
  return (
    <button
      type={type}
      className={`flex size-10 cursor-pointer items-center justify-center rounded-pill border border-line bg-panel text-text hover:bg-panel-2 ${className}`.trim()}
      {...props}
    />
  );
}
